module.exports = __webpack_public_path__ + "static/media/peserta_jkn.745731f2.png";